<template src="./ratesSummaryPanel.template.html"></template>
<script>
import moment from "moment-timezone";

export default {
  name: "ratesSummaryPanel",
  props: ["ratesSummeryPanel", "parentCallback", "hideSummaryPanel"],
  data() {
    return {
      headerColumnList: {
        PropertyName: {
          Label: "Property Name",
          IsChecked: true,
          ColumnName: "PropertyName"
        },
        UnitName: {
          Label: "Unit Name",
          IsChecked: true,
          ColumnName: "UnitName"
        },
        BaseRate: {
          Label: "Base Rate ",
          IsChecked: true,
          ColumnName: "BaseRate"
        },
        RatePerAdditonalAdult: {
          Label: "Extra Person",
          IsChecked: true,
          ColumnName: "AdditionalAdultRate"
        },
        RatePerAdditonalChild: {
          Label: "Extra Child",
          IsChecked: true,
          ColumnName: "AdditionalChildRate"
        },
        DateEffective: {
          Label: "Date Effective",
          IsChecked: true,
          ColumnName: "DateEffective"
        }
      },
      rateOverrideList: [],
      loading: true,
      isSummaryLoading: false,
      rateOverRideDetailId: {},
      ratesDetail: false
    };
  },
  methods: {
    showRatesSummaryPanel() {
      let vm = this;
      // console.log("inst", inst);
      vm.ratesDetail = false;
      $("#ratesSummary").addClass("expand");
      $(".clientList").removeClass("expand");
      $("#notification").removeClass("expand");
      $(".reservationSummary").removeClass("expand");
      $("#restrictionsSummary").removeClass("expand");
      $(".menuMaskRatesSum").toggle();
      $("#ratesSummary").removeClass("menuMaskRatesSum");
      vm.isSummaryLoading = true;
      vm.getRateOverrideList();
      $(this.$el)
        .find("ul.dropdown-menu")
        .click(function(e) {
          e.stopPropagation();
        });
    },
    closeSummaryPannel() {
      $(".menuMaskRatesSum").hide();
      $("#ratesSummary").removeClass("expand");
      if (this.hideSummaryPanel) {
        this.hideSummaryPanel();
      }
    },
    createNewRateOverRide() {
      let vm = this;
      vm.ratesDetail = true;
      vm.rateOverRideDetailId = {
        rateOverRideId: -1
      };
      //   vm.$router.push("/rateOverride/" + "-1");
    },
    getRateOverrideList() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_RateOverride_List",
        params: {
          // ClientId,
          PropertyId: -1,
          UnitId: -1
        },
        callback: function(err, response) {
          if (err) {
            return;
          }
          if (response) {
            for (var i in response.recordsets) {
              // response.recordsets[i].forEach(function (arrayItem) {
              //console.log("response.recordsets[i]", response.recordsets[i])

              // console.log("x", x)
              for (var j in response.recordsets[i]) {
                //console.log("response.recordsets[i][j]", response.recordsets[i][j].DateEffective)
                var x = moment(response.recordsets[i][j].DateEffective).format(
                  "MMM DD YYYY"
                );
                response.recordsets[i][j].DateEffective = x;
                // console.log("response.recordsets[i][j]", response.recordsets[i][j])
              }
              // response.recordsets[i].DateEffective = x;
              // });
            }

            vm.rateOverrideList = response.recordsets[0];
            //console.log("response in rateOverrideList", response.recordsets[0]);
          }
          vm.isSummaryLoading = false;
        }
      });
    },
    viewRateOverrideDetailById(inst) {
      let vm = this;
      console.log("inst", inst);
      vm.ratesDetail = true;
      vm.rateOverRideDetailId = {
        rateOverRideId: inst.RateId
      };
      //   vm.$router.push("/rateOverride/" + inst.RateId);
    },
    hideDetailsSummary() {
      let vm = this;
      vm.ratesDetail = false;
      vm.getRateOverrideList();
    }
  },
  computed: {},
  mounted() {},
  watch: {
    ratesSummeryPanel: {
      handler: function(resObj, oldVal) {
        if (resObj == true) {
          this.showRatesSummaryPanel();
        }
      },
      deep: true
    }
  },
  destroyed() {}
};
</script>